import { AlpineComponent } from "alpinejs";
import { Basket, BasketItem, BasketService, CreateOrderParameters, OrderService } from "../api";

type Checkout = AlpineComponent<{
	company: string;
	firstName: string;
	lastName: string;
	email: string;
	address: string;
	phone: string;
	city: string;
	postalCode: string;
	addressOther: string;
	cityOther: string;
	postalCodeOther: string;
	orderTag: string;
	desiredShippingDate: Date | null;
	otherDeliveryAddress: boolean;
	message: string;
	basket: Basket | undefined;
	removeFromBasket: (lineNo: number) => void;
	updateBasketItem: (basketItem: BasketItem) => void;
	submitOrder: () => void;
}>;

export default (initialBasket: Basket): Checkout => {
	return {
		company: "",
		firstName: "",
		lastName: "",
		email: "",
		address: "",
		city: "",
		postalCode: "",
		addressOther: "",
		cityOther: "",
		postalCodeOther: "",
		orderTag: "",
		message: "",
		phone: "",
		otherDeliveryAddress: false,
		desiredShippingDate: null,
		basket: initialBasket,
		removeFromBasket(lineNo: number) {
			if (!this.basket) {
				console.error("No basket available to remove item from.");
				return;
			}
			BasketService.removeFromBasket({ body: { lineNo: lineNo, basketId: this.basket.id } }).then((response) => {
				this.basket = response.data;
			});
		},
		updateBasketItem(basketItem: BasketItem) {
			if (!this.basket) {
				console.error("No basket available to update item in.");
				return;
			}

			if (basketItem.quantity < 1 || isNaN(basketItem.quantity)) {
				basketItem.quantity = 1;
			} else {
				basketItem.quantity = Math.floor(basketItem.quantity);
			}

			BasketService.updateBasketItem({
				body: {
					lineNo: basketItem.lineNo,
					quantity: basketItem.quantity,
					basketId: this.basket.id,
					partNo: basketItem.partNo,
				},
			}).then((response) => {
				this.basket = response.data;
			});
		},
		async submitOrder() {
			const orderData: CreateOrderParameters = {
				company: this.company,
				firstName: this.firstName,
				lastName: this.lastName,
				email: this.email,
				address: this.otherDeliveryAddress ? this.addressOther : this.address,
				city: this.otherDeliveryAddress ? this.cityOther : this.city,
				postalCode: this.otherDeliveryAddress ? this.postalCodeOther : this.postalCode,
				phone: this.phone,
				orderTag: this.orderTag,
				desiredShippingDate: this.desiredShippingDate,
				message: this.message,
			};
			const response = await OrderService.create({ body: orderData });
			location.href = response.data as string;
		},
	};
};
